<template>
    <div class="more">
                          <span>
          <a>
              <div>
                             <i class="iconfont icon-shuaxin"></i>
              </div>

              <p>READ MORE</p>
          </a>
          </span>
    </div>
</template>

<script>
    export default {
        name: "btn"
    }
</script>

<style lang="scss" scoped>
    .more{
        width:100%;
        text-align: center;
        margin-top: 60px;
        span{
            text-align: center;
            width:150px;
            display: inline-block;
            height:40px;
            line-height: 40px;
            font-family: "Fira Code Medium";
            font-weight: lighter;
            font-size: 13px;
            cursor: pointer;
            position: relative;
            border-bottom: 1px solid #D3D3D3;
            -webkit-transition: all 2s;
            transition: all 2s;
            a{
                position: absolute;
                width:100%;
                left:0;
                display: flex;
                flex-direction: row;
                justify-content: center;
                div{
                    transition: all 2s;
                    position: absolute;
                    left:18%;
                    top:2%;
                    height:95%;
                    i{
                        font-size: 20px;
                        transform-origin: center bottom;
                    }
                }
                p{
                    transition: all 2s;
                    padding-left: 20px;
                }
            }
        }
        span:hover{
            background-color: #00589E;
            div{
                transform: rotate(360deg);
            }
        }
        span:hover{
            background-color: #91C131;
            a{
                p,i{
                    color:white;
                }
            }
        }
        span:hover::after{
            top:-1px;
            right:-1px;
            height:100%;
            width:90px;
        }
    }
</style>